/**
=========================================================
* Soft UI Dashboard PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Styles
import borders from "assets/theme/base/borders";
import boxShadows from "assets/theme/base/boxShadows";
import colors from "assets/theme/base/colors";

// Soft UI Dashboard PRO React helper functions
import linearGradient from "assets/theme/functions/linearGradient";
import pxToRem from "assets/theme/functions/pxToRem";
import rgba from "assets/theme/functions/rgba";

const { white, gradients: lightGradients } = colors.light;
const { gradients: darkGradients, success: darkSuccess } = colors.dark;
const { borderWidth } = borders;
const { regular } = boxShadows;

export default {
  defaultProps: {
    disableRipple: true,
  },

  styleOverrides: {
    root: {
      width: pxToRem(40),
      height: pxToRem(20),
      margin: `${pxToRem(4)} 0`,
      padding: 0,
      borderRadius: pxToRem(160),
      transition: "transform 250ms ease-in",
    },

    switchBase: ({ theme }) => {
      const isDark = theme?.palette?.mode === "dark";
      const checkedTrackBg = isDark ? darkSuccess.main : rgba(lightGradients.dark.state, 0.95);
      const checkedTrackBorder = isDark ? darkSuccess.focus : rgba(lightGradients.dark.state, 0.95);

      return {
        padding: 0,
        top: "50%",
        transform: `translate(${pxToRem(2)}, -50%)`,
        transition: `transform 250ms ease-in-out`,

        "&.Mui-checked": {
          transform: `translate(${pxToRem(22)}, -50%)`,

          "& + .MuiSwitch-track": {
            backgroundColor: `${checkedTrackBg} !important`,
            borderColor: `${checkedTrackBorder} !important`,
            opacity: 1,
          },
        },

        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: "0.3 !important",
        },

        "&.Mui-focusVisible .MuiSwitch-thumb": {
          backgroundImage: linearGradient(
            isDark ? darkGradients.info.main : lightGradients.info.main,
            isDark ? darkGradients.info.state : lightGradients.info.state
          ),
        },
      };
    },

    thumb: {
      width: pxToRem(16),
      height: pxToRem(16),
      backgroundColor: white.main,
      boxShadow: regular,
      top: "50%",
    },

    track: ({ theme }) => {
      const isDark = theme?.palette?.mode === "dark";

      return {
        backgroundColor: isDark ? "rgba(255,255,255,0.12)" : rgba(lightGradients.dark.state, 0.1),
        border: isDark
          ? `${borderWidth[1]} solid rgba(255,255,255,0.25)`
          : `${borderWidth[1]} solid ${colors.light.light.main}`,
        borderRadius: pxToRem(160),
        opacity: 1,
        transition: `background-color 250ms ease, border-color 200ms ease`,
      };
    },

    checked: {},
  },
};
